import { create } from "zustand";
import {
  NOTIFICATIONS_TABS,
  PAGINATION_MIN,
  PAYMENT_METHODS,
  REPORTS_TABS,
  TRANSACTIONS_TABS,
} from "../helpers/constants";

const userPreferencesStore = create((set: any, get: any) => ({
  rightPanelIsVisible: !localStorage?.getItem?.("hideRightPanel"),
  transactionsFilterIsOpen: false,
  transactionsActiveTab: TRANSACTIONS_TABS.ACTIVE_TRANSACTIONS,
  reportsActiveTab: REPORTS_TABS.TRANSACTIONS_LAST_SEVEN_DAYS,
  notificationsActiveTab: NOTIFICATIONS_TABS.RECURRING_TRANSACTIONS,
  lastUsedPaymentMethod: PAYMENT_METHODS()[5].id,
  lastUsedAccount: "",
  defaultAccount: "",
  reportsSelectedAccount: "",
  transactionsSelectedAccount: "",
  tableResultsPerPage:
    Number(localStorage?.getItem?.("results-per-page")) || PAGINATION_MIN,
  notesActiveTab: 0,
  isDarkMode: localStorage?.getItem?.("theme") === "dark",
  selectedYear: "",
  setRightPanelIsVisible: (isVisible: boolean) => {
    if (isVisible) {
      localStorage?.removeItem?.("hideRightPanel");
    } else {
      localStorage?.setItem?.("hideRightPanel", "true");
    }
    set({ rightPanelIsVisible: isVisible });
  },

  setIsDarkMode: (isActive: boolean) => {
    set({ isDarkMode: isActive });
  },

  setSelectedYear: (year: string) => {
    set({ selectedYear: year });
  },

  setTransactionsFilterIsOpen: (isOpen: boolean) => {
    set({ transactionsFilterIsOpen: isOpen });
  },

  setTransactionsActiveTab: (tab: number) => {
    set({ transactionsActiveTab: tab });
  },

  setNotificationsActiveTab: (tab: number) => {
    set({ notificationsActiveTab: tab });
  },

  setReportsActiveTab: (tab: number) => {
    set({ reportsActiveTab: tab });
  },

  setNotesActiveTab: (tab: number) => {
    set({ notesActiveTab: tab });
  },

  setLastUsedPaymentMethod: (methodId: string) => {
    set({ lastUsedPaymentMethod: methodId });
  },

  setLastUsedAccount: (accountId: string) => {
    set({ lastUsedAccount: accountId });
  },

  setDefaultAccount: (accountId: string) => {
    set({ defaultAccount: accountId });
  },

  setReportsSelectedAccount: (accountId: string) => {
    set({ reportsSelectedAccount: accountId });
  },

  setTransactionsSelectedAccount: (accountId: string) => {
    set({ transactionsSelectedAccount: accountId });
  },

  setTableResultsPerPage: (perPage: number) => {
    localStorage?.setItem?.("results-per-page", `${perPage}`);
    set({ tableResultsPerPage: perPage });
  },
}));

export default userPreferencesStore;
